import React from "react";
import { FormattedMessage } from "react-intl";

const pStyles = {
  display: "flex",
  width: "100%",
  alignItems: "flex-end",
  justifyContent: "flex-end",
  marginBottom: 10,
  fontSize: "8pt",
  color: "black",
};

const RequiredCaption = () => (
  <div className={"field-info"} style={pStyles}>
    <FormattedMessage id="requiredFields" />
  </div>
);

export default RequiredCaption;
